// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ab41cc3","732":"3685ed76","977":"e60fbd3f"}[chunkId] + ".chunk.js";
};